export default __webpack_public_path__ + "static/media/Bullet.f3d6e9d8.svg";